import registerTable from '../../../common/table/index';
import presentationalComponent from './Table';
import containerComponent from './TableContainer';

import { isApple } from '../../utils/services/browser';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';
import { TABLE_CELL_EDITOR_KEY } from '../../../common/table/tableConstants';

export default () => {
    const isEditingCell = (hasEditorSelection, editorKey) => hasEditorSelection && editorKey === TABLE_CELL_EDITOR_KEY;

    return registerTable({
        containerComponent,
        presentationalComponent,
        tools: [
            TOOLS.TABLE_OPERATIONS,
            {
                ...TOOLS.TITLE,
                predicate: (element, selectedElements, currentUser, hasEditorSelection, editorKey) =>
                    !isEditingCell(hasEditorSelection, editorKey),
            },
            {
                ...TOOLS.CAPTION,
                predicate: (element, selectedElements, currentUser, hasEditorSelection, editorKey) =>
                    !isEditingCell(hasEditorSelection, editorKey),
            },
        ],
        tooltip: isApple ? '⌃⌘N' : 'Ctrl+Alt+N',
    });
};
